import { Signer } from "@aws-amplify/core";
import axios from "axios";

export async function signedRequest(
    method,
    url,
    data,
    credentials,
    apikey,
    options
) {
    let headers = {};

    if (apikey) {
        headers.Authorization = `Bearer ${apikey}`;
    }

    let request = {
        method,
        url,
        headers,
        data,
    };

    let access_info = {
        access_key: credentials.accessKeyId,
        secret_key: credentials.secretAccessKey,
        session_token: credentials.sessionToken,
    };

    let service_info = {
        service: "execute-api",
        region: "ap-southeast-1",
    };

    if (options) {
        if (options.service) {
            service_info.service = options.service;
        }
    }

    let signedUrl = Signer.signUrl(request, access_info, service_info, 300);
    return await axios.get(signedUrl, {
        headers,
    });
}
